<script setup lang="ts">

import type {PortfolioFilters} from "~/types/Portfolio";
import type {SpecificationType} from "~/types/Specification";
import { Button } from '~/components/ui/button'
import SelectLocation from '~/components/custom-ui/SelectLocation.vue'
import { RadioGroup, RadioGroupItem } from '~/components/ui/radio-group'
import { Slider } from '~/components/ui/slider'
import BtnFilterRangeInline from '~/components/custom-ui/BtnFilterRangeInline.vue'
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '~/components/ui/select'

const props = defineProps({
    filtersList: {
        type: Object as PropType<PortfolioFilters>,
        default: () => null
    },
    mastersCount: {
        type: Number,
        default: 0
    },
    parentSpecification: {
        type: Object as PropType<SpecificationType>,
        default: null
    },
    specificationChildList: {
        type: Array as PropType<SpecificationType[]>,
        default: () => []
    },
    filterForm: {
        type: Object,
        default: () => null
    }
})

const emit = defineEmits(['submit', 'back', 'closeFiltersModal'])

const route = useRoute();
const router = useRouter()
const userStore = useUserStore();
const { t } = useI18n();
const { parentSpecifications, specifications } = useGlobalStore();

const FiltersModeEnum = {
    FILTERS: 'filters',
    PARENT_CATS: 'parent_category',
    CHILD_CATS: 'child_categories',
} as const;

const CurrencyEnum = {
    AED: 'AED',
    USD: 'USD',
    EUR: 'EUR',
} as const;

const activeMode = ref<typeof FiltersModeEnum[keyof typeof FiltersModeEnum]>(FiltersModeEnum.FILTERS);

const localFilters = ref({
    specificationId: [route.params.id as string],
    city: [],
    educationType: null,
    employmentType: null,
    isRemote: null,
    minLat: null,
    maxLat: null,
    minLng: null,
    maxLng: null,
    priceFrom: null,
    priceTo: null,
    pageSize: 15,
    page: 1,
    reviewsCount: null,
    experience: null,
})

const selectedLocalFilterSpecification = computed(() => {
    return specifications.find(item => item.documentId === localFilters.value.specificationId[0]) || null
})
const selectedParentCategoryId = ref<string | null | undefined>(null);

const priceRange = computed({
    get: () => [localFilters.value.priceFrom, localFilters.value.priceTo],
    set: ([from, to]) => {
        localFilters.value.priceFrom = from
        localFilters.value.priceTo = to
    }
})

function initialPriceRange(){
    if(props.filtersList?.price){
        priceRange.value = [props.filtersList.price.from, props.filtersList.price.to]
    }
}

initialPriceRange()


onMounted(() => {
    console.log(props.filterForm)
    if(props.filterForm) localFilters.value = props.filterForm
})
</script>

<template>
<div class="">
    <div v-if="activeMode === FiltersModeEnum.FILTERS" class="grid gap-4">
        <div class="page_title">
            <div class="flex items-center gap-6">
                <Button class="hidden lg:flex p-3 h-auto text-black" variant="lighter" @click.prevent="emit('back')">
                    <Icon name="ri:arrow-left-line" size="24px"/>
                </Button>
                <Button class="flex lg:hidden p-3 h-auto text-black" variant="lighter" @click.prevent="emit('closeFiltersModal')">
                    <Icon name="ri:arrow-left-line" size="24px"/>
                </Button>
                <p class="font-semibold text-xl">Filters</p>
            </div>
        </div>
        <Button class="p-3 h-auto w-full rounded-lg text-dark justify-between mt-4" variant="outline" @click.prevent="activeMode = FiltersModeEnum.PARENT_CATS">
            <span class="font-medium text-base">{{ selectedLocalFilterSpecification?.name }}</span>
            <Icon name="ri:arrow-right-line" size="24px"/>
        </Button>
        <div class="grid grid-cols-12 gap-6 items-end">
            <div v-if="filtersList?.cities?.length" class="col-span-12 lg:col-span-5">
                <p class="text-sm mb-2">{{ $t('Service area') }}</p>
                <SelectLocation
                        v-model="localFilters.city"
                        :default="userStore.currentCity.documentId" class="w-full"
                        :options="filtersList.cities"
                />
            </div>
            <div class="col-span-12 lg:col-span-7">
                <RadioGroup v-model="localFilters.isRemote" class="flex gap-2">
                    <label class="flex items-center justify-between space-x-2 border rounded-xl border-gray-200 px-4 py-3 w-1/2">
                        <span class="text-sm break-words">{{ $t('Remote') }}</span>
                        <RadioGroupItem class="text-primary-500" :value="true"/>
                    </label>
                    <label class="flex items-center justify-between space-x-2 border rounded-xl border-gray-200 px-4 py-3 w-1/2">
                        <span class="text-sm break-words">{{ $t('On Site') }}</span>
                        <RadioGroupItem class="text-primary-500" :value="false"/>
                    </label>
                </RadioGroup>
            </div>
        </div>
        <!--                    <UiTabs v-model="selectedCurrency" :default-value="CurrencyEnum.AED" class="w-full">
								<p class="text-sm mb-2">{{ $t('Сurrency') }}</p>
								<UiTabsList class="grid grid-cols-3 border border-gray-200 rounded-xl overflow-hidden">
									<UiTabsTrigger
										:class="{
										'!bg-stroke': selectedCurrency === CurrencyEnum.AED
									}"
										:value="CurrencyEnum.AED"
										class="border-r border-gray-200 last:border-r-0 p-2"
									>
										<Icon class="mr-2 rtl:ml-2" name="circle-flags:ae" size="20px"/>
										<span>{{ CurrencyEnum.AED }}</span>
									</UiTabsTrigger>
									<UiTabsTrigger
										:class="{
										'!bg-stroke': selectedCurrency === CurrencyEnum.USD
									}"
										:value="CurrencyEnum.USD"
										class="border-r border-gray-200 last:border-r-0 p-2"
									>
										<Icon class="mr-2 rtl:ml-2" name="circle-flags:us" size="20px"/>
										<span>{{ CurrencyEnum.USD }}</span>
									</UiTabsTrigger>
									<UiTabsTrigger
										:class="{
										'!bg-stroke': selectedCurrency === CurrencyEnum.EUR
									}"
										:value="CurrencyEnum.EUR"
										class="border-r border-gray-200 last:border-r-0 p-2"
									>
										<Icon class="mr-2 rtl:ml-2" name="circle-flags:eu" size="20px"/>
										<span>{{ CurrencyEnum.EUR }}</span>
									</UiTabsTrigger>
								</UiTabsList>
							</UiTabs>-->

        <div v-if="filtersList?.price">
            <p class="text-sm mb-2">{{ $t('Price Range') }}</p>
            <Slider
                    v-model="priceRange"
                    :min="filtersList?.price?.from || 0"
                    :max="filtersList?.price?.to || 1000"
                    :step="100"
                    class="mt-4"
            />
            <BtnFilterRangeInline
                    v-model:min-value="localFilters.priceFrom"
                    v-model:max-value="localFilters.priceTo"
                    :min="filtersList?.price?.from || 0"
                    :max="filtersList?.price?.to || 1000"
                    class="mt-6"/>
        </div>

        <div class="grid lg:grid-cols-2 gap-4">
            <!-- <div v-if="filtersList?.reviews" class="">
                <p class="text-sm mb-2">{{ $t('Reviews') }}</p>
                <UiSelect v-model="localFilters.reviewsCount" class="w-full">
                    <UiSelectTrigger
                            class="w-full h-12 !ring-0 !ring-offset-0 rtl:flex-row-reverse justify-between font-normal text-sub text-sm">
                        <div class="flex items-center rtl:flex-row-reverse">
                            <UiSelectValue placeholder="Select variant"/>
                        </div>
                    </UiSelectTrigger>
                    <UiSelectContent>
                        <UiSelectItem v-for="option in filtersList.reviews" :value="option.value"
                                      class="hover:bg-stroke">
                            {{ option.label }}
                        </UiSelectItem>
                    </UiSelectContent>
                </UiSelect>
            </div> -->

            <div v-if="filtersList?.experiences" class="">
                <p class="text-sm mb-2">{{ $t('Work experience') }}</p>
                <Select v-model="localFilters.experience" class="w-full">
                    <SelectTrigger
                            class="w-full h-12 !ring-0 !ring-offset-0 rtl:flex-row-reverse justify-between font-normal text-sub text-sm">
                        <div class="flex items-center rtl:flex-row-reverse">
                            <SelectValue placeholder="Select variant"/>
                        </div>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem v-for="option in filtersList?.experiences" :value="option.value" class="hover:bg-stroke">
                            {{ option.label }}
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>
        </div>
        <div v-if="filtersList?.employments" class="grid grid-cols-12 gap-4 items-end">
            <div class="col-span-12 lg:col-span-5">
                <p class="text-sm mb-2">{{ $t('Employment') }}</p>
                <Select v-model="localFilters.employmentType" class="w-full">
                    <SelectTrigger
                            class="w-full h-12 !ring-0 !ring-offset-0 rtl:flex-row-reverse justify-between font-normal text-sub text-sm">
                        <div class="flex items-center rtl:flex-row-reverse">
                            <SelectValue placeholder="Select variant"/>
                        </div>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem v-for="option in filtersList?.employments" :value="option.documentId" class="hover:bg-stroke">
                            {{ option.name }}
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>
            <div v-if="filtersList?.educations" class="col-span-12 lg:col-span-7">
                <p class="text-sm mb-2">{{ $t('Education') }}</p>
                <Select v-model="localFilters.educationType" class="w-full">
                    <SelectTrigger
                            class="w-full h-12 !ring-0 !ring-offset-0 rtl:flex-row-reverse justify-between font-normal text-sub text-sm">
                        <div class="flex items-center rtl:flex-row-reverse">
                            <SelectValue placeholder="Select variant"/>
                        </div>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem v-for="option in filtersList?.educations" :value="option.documentId" class="hover:bg-stroke">
                            {{ option.name }}
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>
        </div>
        <div class="mt-0">
            <Button class="text-dark w-full p-6" variant="lighter" @click.prevent="emit('submit', localFilters)">
                {{ $t('Show') }}
            </Button>
            <div v-if="mastersCount" class="masters_count text-center text-gray-400 text-sm mt-2">
                {{ mastersCount }} {{ $t('specialists nearby') }}
            </div>
        </div>
    </div>

    <div v-if="activeMode === FiltersModeEnum.PARENT_CATS" class="aside order-2 lg:order-1 lg:col-span-4">
        <div class="page_title mb-8">
            <div class="flex items-center gap-6">
                <Button class="p-3 h-auto text-black" variant="lighter" @click.prevent="activeMode = FiltersModeEnum.FILTERS">
                    <Icon name="ri:arrow-left-line" size="24px"/>
                </Button>
                <p class="font-semibold text-xl">{{ $t('Main category') }}</p>
            </div>
        </div>

        <ul class="nav">
            <li v-for="item in parentSpecifications" class="border-b border-gray-200">
                <div
                        :class="{'font-bold': item.documentId === selectedParentCategoryId }"
                        class="list-container w-full py-2 transition-all hover:pl-4 rtl:hover:pr-4 flex items-center cursor-pointer"
                        @click.prevent="selectedParentCategoryId = item.documentId; activeMode = FiltersModeEnum.CHILD_CATS">
                    <span>{{ item.name }}</span>
                    <Icon class="ml-auto text-gray-500" name="ri:arrow-right-s-line" size="20px"/>
                </div>
            </li>
        </ul>
    </div>

    <div v-if="activeMode === FiltersModeEnum.CHILD_CATS" class="aside order-2 lg:order-1 lg:col-span-4">
        <div class="page_title mb-8">
            <div class="flex items-center gap-6">
                <Button class="p-3 h-auto text-black" variant="lighter">
                    <Icon name="ri:arrow-left-line" size="24px"/>
                </Button>
                <p class="font-semibold text-xl">{{ parentSpecification.name }}</p>
            </div>
        </div>

        <ul class="nav">
            <li v-for="item in specificationChildList" class="border-b border-gray-200">
                <div
                        :class="{'font-bold': item.documentId == filterForm.specificationId[0] }"
                        class="list-container w-full py-2 transition-all hover:pl-4 rtl:hover:pr-4 flex items-center cursor-pointer"
                        @click.prevent="localFilters.specificationId = [item.documentId]; activeMode = FiltersModeEnum.FILTERS">
                    <span>{{ item.name }}</span>
                    <Icon class="ml-auto text-gray-500" name="ri:arrow-right-s-line" size="20px"/>
                </div>
            </li>
        </ul>
    </div>
</div>
</template>